import { Policyholder } from '../../../domain'
import { InputConfig } from '../../../state/configuration'

export const toPolicyholderData = (policyholder: Policyholder) => (input: InputConfig) =>
  policyholder[input.name]
